module.exports = __webpack_public_path__ + "static/media/no_available.4a7a5b2e.png";